import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ForumIcon from "@mui/icons-material/Forum";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import PersonRemoveOutlinedIcon from "@mui/icons-material/PersonRemoveOutlined";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {
  AppBar,
  Avatar,
  Box,
  Card,
  Container,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Modal,
  Toolbar,
  Tooltip,
  Typography,
} from "@mui/material";
import jwt_decode from "jwt-decode";
import moment from "moment";
import PropTypes from "prop-types";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SockJS from "sockjs-client/dist/sockjs";
import Stomp from "stompjs";
import keyIcon from "../../assets/images/png/key.png";
import CustomButton from "../../components/CustomButton";
import CustomModal from "../../components/CustomModal/CustomModal";
import CustomTextField from "../../components/CustomTextField";
import EditProfileModal from "../../components/EditProfileModal/EditProfileModal";
import api from "../../redux/actions/api";
import { logout } from "../../redux/reducers/authSlice";
import { getChatListWithoutLoading } from "../../redux/reducers/chatSlice";
import {
  getAuthTokenBasedOnClinicId,
  getClinicAppointemntListWithoutLoading,
  getClinicDashboardDataWoLoader,
  getClinicInpatientsWoLoader,
  getClinicNotification,
  getClinicNotificationWoLoader,
  getVetAppointmentsByIdAndFilterWoLoader,
  getVetDetailsById,
  updateUserActiveBranch,
} from "../../redux/reducers/clinicSlice";
import {
  hideLoader,
  navWidths,
  showLoader,
} from "../../redux/reducers/loaderSlice";
import { markNotificationsReadByIds } from "../../redux/reducers/notificationSlice";
import { showSnackBar } from "../../redux/reducers/snackSlice";
import { AppColors } from "../../util/AppColors";
import { getPrimaryRole, parseAllRoles } from "../../util/accessList";
import {
  MANDATE_STORAGE_KEY,
  readMandateSession,
} from "../../util/mandateSessionStorage";
import { baseURL, socketServer } from "../../util/server";
import { getNavConfigForRoles, navPathsEqual } from "../nav/config";
import "./Header.css";

const ACCESSIBLE_ACCOUNTS_KEY = "accessableAccounts";

const getAccessibleAccountId = (account) =>
  account?.id ?? account?.doctorId ?? null;

const isSameAccessibleAccount = (account, compareId) => {
  const accountId = getAccessibleAccountId(account);
  if (!accountId || compareId == null) return false;
  return String(accountId) === String(compareId);
};

const getAccessibleAccounts = () => {
  try {
    const stored = localStorage.getItem(ACCESSIBLE_ACCOUNTS_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const saveAccessibleAccounts = (accounts = []) => {
  const prevAccounts = getAccessibleAccounts();
  const accountMap = new Map(
    prevAccounts
      .filter((acc) => getAccessibleAccountId(acc))
      .map((acc) => [String(getAccessibleAccountId(acc)), acc]),
  );

  accounts.forEach((account) => {
    const accountId = getAccessibleAccountId(account);
    if (accountId) {
      accountMap.set(String(accountId), account);
    }
  });

  const reqList = Array.from(accountMap.values());
  if (reqList.length === 0) return;

  localStorage.setItem(ACCESSIBLE_ACCOUNTS_KEY, JSON.stringify(reqList));
};

const saveAccessibleAccount = (account) => {
  saveAccessibleAccounts([account]);
};

const removeAccessibleAccount = (accountId) => {
  if (!accountId) return;
  const prevAccounts = getAccessibleAccounts();
  const reqList = prevAccounts.filter(
    (acc) => !isSameAccessibleAccount(acc, accountId),
  );
  if (reqList.length === 0) {
    localStorage.removeItem(ACCESSIBLE_ACCOUNTS_KEY);
    return;
  }
  localStorage.setItem(ACCESSIBLE_ACCOUNTS_KEY, JSON.stringify(reqList));
};

const clearAccessibleAccounts = () => {
  localStorage.removeItem(ACCESSIBLE_ACCOUNTS_KEY);
};

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const stompClientRef = useRef(null);
  const handlersRef = useRef({});
  const role = getPrimaryRole();
  if (role && localStorage.getItem("role") !== role) {
    localStorage.setItem("role", role);
  }
  const [navItems, setNavItems] = useState(() =>
    getNavConfigForRoles(parseAllRoles()),
  );
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const [selectedTab, setSelectedTab] = useState(
    location.pathname || "/dashboard",
  );
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [notModVsble, setNotModVsble] = useState(false);
  const [qrVsble, setQrVsble] = useState(false);
  const [addAccModVsble, setAddAccModVsble] = useState(false);
  const [profileEditModVisible, setProfileEditModVisible] = useState(false);
  const [switchAccModVsble, setSwitchAccModVsble] = useState(false);
  const [logoutSwitchAccounts, setLogoutSwitchAccounts] = useState([]);
  const [addAccValues, setAddAccValues] = useState({});
  const [accessibleAccounts, setAccessibleAccounts] = useState([]);
  const [branchMenuEl, setBranchMenuEl] = useState(null);
  const [mandateTick, setMandateTick] = useState(0);
  const {
    notifications,
    appointmentList: appointemnts,
    branchesByClinicId,
    mainClinicDetails,
  } = useSelector((state) => state?.clinic);
  const chatList = useSelector((state) => state?.chat?.list);
  const comObjVal = useSelector((state) => state?.mixed?.comObj);

  useEffect(() => {
    dispatch(navWidths(false));
    if (!localStorage.getItem("accessToken")) return;
  }, []);

  useEffect(() => {
    const syncNavItems = () => {
      const nextNav = getNavConfigForRoles(parseAllRoles());
      setNavItems((prev) => (navPathsEqual(prev, nextNav) ? prev : nextNav));
      setMandateTick((t) => t + 1);
    };
    syncNavItems();
    window.addEventListener("mandate-session-updated", syncNavItems);
    return () => {
      window.removeEventListener("mandate-session-updated", syncNavItems);
    };
  }, []);

  // Sync selectedTab with current location
  useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath !== selectedTab) {
      setSelectedTab(currentPath);
    }
  }, [location.pathname, selectedTab]);

  useEffect(() => {
    if (!profile?.id) return;
    let stompClient;
    let reconnectAttempts = 0;
    const connectSocket = () => {
      stompClient = Stomp.over(new SockJS(socketServer));
      stompClientRef.current = stompClient;
      stompClient.connect(
        {},
        () => {
          console.log("WebSocket connection opened");
          stompClient.subscribe(
            `/user/${profile?.id}/topic/notification`,
            (message) => {
              const parsedData = JSON.parse(message?.body);
              handlersRef.current.handleNotifications(parsedData);
            },
          );
          stompClient.subscribe(
            `/user/${profile?.id}/topic/chatUser`,
            (message) => {
              const parsedData = JSON.parse(message?.body);
              handlersRef.current.handleChat(parsedData);
            },
          );
          stompClient.subscribe(
            `/user/${profile?.id}/topic/inpatient`,
            (res) => {
              handlersRef.current.handleInpatients(res);
            },
          );
          stompClient.subscribe(
            `/user/${profile?.id}/topic/dashboard`,
            (res) => {
              handlersRef.current.handleDashboard(res);
            },
          );
        },
        (error) => {
          console.error("WebSocket connection error:", error);
          handleReconnect();
        },
      );
    };
    const handleReconnect = () => {
      if (reconnectAttempts < 5) {
        const delay = Math.min(5000 * Math.pow(2, reconnectAttempts), 30000); // Exponential backoff, max 30s
        setTimeout(() => {
          reconnectAttempts += 1;
          console.log(`Reconnecting attempt #${reconnectAttempts}`);
          connectSocket();
        }, delay);
      } else {
        console.error("Max reconnect attempts reached.");
      }
    };
    connectSocket();
    return () => {
      if (stompClient && stompClient?.connected) {
        stompClient?.disconnect();
      }
    };
  }, [profile?.id]);

  useEffect(() => {
    // Update handlers when chatList or comObjVal change
    handlersRef.current.handleNotifications = (parsedData) => {
      // dispatch(
      //   showSnackBar({
      //     title: parsedData?.title,
      //     message: parsedData?.message,
      //     type: "notification",
      //   }),
      // );
      dispatch(getClinicNotificationWoLoader()); //dispatch(getClinicNotification());
      if (parsedData?.title === "Appointment Request") {
        dispatch(getClinicAppointemntListWithoutLoading("?type=appointment"));
      }
    };
    handlersRef.current.handleChat = (parsedData) => {
      const isChatIdMatch = chatList?.find((ct) => ct?.chatId === parsedData);
      if (isChatIdMatch) {
        //for calling chat count patch in header
        dispatch(getChatListWithoutLoading());
      }
    };
    handlersRef.current.handleInpatients = (res) => {
      //for calling clinic pet details
      if (
        comObjVal?.petDetails?.appointmentId ||
        comObjVal?.petDetails?.petId
      ) {
        // if (comObjVal?.petDetails?.appointmentId) {
        //   dispatch(
        //     getPetsCompliantSummaryWoLoader(
        //       comObjVal?.petDetails?.appointmentId,
        //     ),
        //   );
        //   // dispatch(
        //   //   getPetsCompliantSummary(comObjVal?.petDetails?.appointmentId)
        //   // );
        // } else {
        //   dispatch(
        //     getPetDetailForSoapByIdWoLoader(comObjVal?.petDetails?.petId),
        //   );
        //   // dispatch(getPetDetailsById(comObjVal?.petDetails?.petId));
        // }
      }
      if (comObjVal?.inpatient?.selectedVet) {
        let url = "?type=all";
        if (comObjVal?.inpatient?.selectedVet !== "All") {
          url = `?type=doctor&doctorId=${comObjVal?.inpatient?.selectedVet}`;
        }
        dispatch(getClinicInpatientsWoLoader(url));
      }
      // if (comObjVal?.admissionDetails?.inpatientId) {
      //   dispatch(
      //     getInpatientById({
      //       inpatientId: comObjVal?.admissionDetails?.inpatientId,
      //       url: `?date=${moment(
      //         new Date(comObjVal?.admissionDetails?.date)
      //       ).format("YYYY-MM-DD")}`,
      //     })
      //   );
      // }
    };
    handlersRef.current.handleDashboard = (res) => {
      //for calling dashboard api
      if (
        comObjVal?.home?.selectedTab === "Outpatient" ||
        comObjVal?.home?.selectedTab === "Virtual" ||
        comObjVal?.home?.selectedTab === "Home"
      ) {
        const reqObj = { type: comObjVal?.home?.selectedTab };
        if (comObjVal?.home?.selectedVet) {
          reqObj.url = `&doctorId=${comObjVal?.home?.selectedVet}`;
        }
        dispatch(getClinicDashboardDataWoLoader(reqObj));
        // dispatch(getClinicDashboardData(reqObj));
      } else {
        let url = "?type=all";
        if (comObjVal?.home?.selectedVet) {
          url = `?type=doctor&doctorId=${comObjVal?.home?.selectedVet}`;
        }
        dispatch(getClinicInpatientsWoLoader(url));
      }

      //for calling vet calendar api
      if (comObjVal?.vetCal?.userId !== null) {
        dispatch(
          getVetAppointmentsByIdAndFilterWoLoader(
            `${comObjVal?.vetCal?.userId}?type=${
              comObjVal?.vetCal?.selectedType
            }${
              comObjVal?.vetCal?.selectedType === "date"
                ? `&date=${moment(comObjVal?.vetCal?.selectedDate).format(
                    "YYYY-MM-DD",
                  )}`
                : ""
            }`,
          ),
        );
        // dispatch(
        //   getVetAppointmentsByIdAndFilter(
        //     `${comObjVal?.vetCal?.userId}?type=${
        //       comObjVal?.vetCal?.selectedType
        //     }${
        //       comObjVal?.vetCal?.selectedType === "date"
        //         ? `&date=${moment(comObjVal?.vetCal?.selectedDate).format(
        //             "YYYY-MM-DD",
        //           )}`
        //         : ""
        //     }`,
        //   ),
        // );
      }

      //for calling clinic pet details
      // if (
      //   comObjVal?.petDetails?.appointmentId ||
      //   comObjVal?.petDetails?.petId
      // ) {
      //   if (comObjVal?.petDetails?.appointmentId) {
      //     dispatch(
      //       getPetsCompliantSummaryWoLoader(
      //         comObjVal?.petDetails?.appointmentId,
      //       ),
      //     );
      //     // dispatch(
      //     //   getPetsCompliantSummary(comObjVal?.petDetails?.appointmentId),
      //     // );
      //   } else {
      //     dispatch(getPetDetailsByIdWoLoader(comObjVal?.petDetails?.petId));
      //     // dispatch(getPetDetailsById(comObjVal?.petDetails?.petId));
      //   }
      // }

      //for calling appointments
      // if (comObjVal?.appointments?.selectedVet?.value === "all") {
      //   // dispatch(
      //   //   getAppointsmentsByClinicWoLoader(
      //   //     `?type=${comObjVal?.appointments?.selectedType}${
      //   //       comObjVal?.appointments?.selectedType === "date"
      //   //         ? `&date=${moment(comObjVal?.appointments?.selectedDate).format(
      //   //             "YYYY-MM-DD",
      //   //           )}`
      //   //         : ""
      //   //     }`,
      //   //   ),
      //   // );

      //   // dispatch(
      //   //   getAppointsmentsByClinic(
      //   //     `?type=${comObjVal?.appointments?.selectedType}${
      //   //       comObjVal?.appointments?.selectedType === "date"
      //   //         ? `&date=${moment(comObjVal?.appointments?.selectedDate).format(
      //   //             "YYYY-MM-DD",
      //   //           )}`
      //   //         : ""
      //   //     }`,
      //   //   ),
      //   // );
      // } else {
      //   dispatch(
      //     getVetAppointmentsByIdAndFilterWoLoader(
      //       `${comObjVal?.appointments?.selectedVet?.value}?type=${
      //         comObjVal?.appointments?.selectedType
      //       }${
      //         comObjVal?.appointments?.selectedType === "date"
      //           ? `&date=${moment(comObjVal?.appointments?.selectedDate).format(
      //               "YYYY-MM-DD",
      //             )}`
      //           : ""
      //       }`,
      //     ),
      //   );
      //   // dispatch(
      //   //   getVetAppointmentsByIdAndFilter(
      //   //     `${comObjVal?.appointments?.selectedVet?.value}?type=${
      //   //       comObjVal?.appointments?.selectedType
      //   //     }${
      //   //       comObjVal?.appointments?.selectedType === "date"
      //   //         ? `&date=${moment(comObjVal?.appointments?.selectedDate).format(
      //   //             "YYYY-MM-DD",
      //   //           )}`
      //   //         : ""
      //   //     }`,
      //   //   ),
      //   // );
      // }
    };
  }, [chatList, comObjVal]);

  const performFullLogout = () => {
    dispatch(logout());
    sessionStorage.clear();
    localStorage.removeItem("switchedFrom");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("allRoles");
    localStorage.removeItem("userId");
    localStorage.removeItem("hospitalId");
    localStorage.removeItem("fcmToken");
    localStorage.removeItem("user");
    localStorage.removeItem("presApiSaved");
    localStorage.removeItem("presUnsavedList");
    localStorage.removeItem("unSavedProced");
    localStorage.removeItem("unSavedWorkbook");
    navigate("/login");
  };

  const handleLogout = () => {
    const logoutUserId =
      getAccessibleAccountId(profile) || localStorage.getItem("userId");
    const otherAccounts = getAccessibleAccounts().filter(
      (acc) =>
        getAccessibleAccountId(acc) &&
        !isSameAccessibleAccount(acc, logoutUserId),
    );

    removeAccessibleAccount(logoutUserId);
    setAccessibleAccounts(otherAccounts);
    setAnchorElUser(null);

    if (otherAccounts.length > 0) {
      setLogoutSwitchAccounts(otherAccounts);
      setSwitchAccModVsble(true);
      return;
    }

    performFullLogout();
  };

  const handleCloseSwitchAccModal = () => {
    setSwitchAccModVsble(false);
    setLogoutSwitchAccounts([]);
    performFullLogout();
  };

  const handleOpenUserMenu = (event) => {
    const currentAccountId = getAccessibleAccountId(profile);
    if (currentAccountId) {
      saveAccessibleAccount(profile);
    }
    setAccessibleAccounts(
      getAccessibleAccounts().filter(
        (acc) =>
          getAccessibleAccountId(acc) &&
          !isSameAccessibleAccount(acc, currentAccountId),
      ),
    );
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const getNavigatePathByRole = (userRole) => {
    if (userRole === "ROLE_ADMIN") return "/home";
    if (userRole === "ROLE_BILLING") return "/payments";
    if (userRole === "ROLE_INVENTORY") return "/inventory";
    if (userRole === "ROLE_GROOMER") return "/groomdashboard";
    if (userRole === "ROLE_PHARMACY") return "/phramacydashboard";
    if (userRole === "ROLE_RADIOLOGY") return "/labdashboard";
    return "/dashboard";
  };

  const handleSwitchAccount = (account, options = {}) => {
    const { fromLogout = false } = options;
    const accountId = getAccessibleAccountId(account);
    const currentAccountId = getAccessibleAccountId(profile);
    if (!accountId || isSameAccessibleAccount(account, currentAccountId))
      return;

    setAnchorElUser(null);
    setSwitchAccModVsble(false);
    setLogoutSwitchAccounts([]);
    dispatch(showLoader());

    if (currentAccountId && !fromLogout) {
      saveAccessibleAccount(profile);
      localStorage.setItem(
        "switchedFrom",
        JSON.stringify({ id: currentAccountId }),
      );
    }

    dispatch(getAuthTokenBasedOnClinicId({ clinicId: accountId })).then(
      async (res) => {
        const reqData = res?.payload?.data;
        if (!reqData?.accessToken) {
          dispatch(hideLoader());
          dispatch(
            showSnackBar({
              message: "Unable to switch account!",
              type: "error",
            }),
          );
          return;
        }

        sessionStorage.clear();

        localStorage.setItem("accessToken", reqData.accessToken);
        if (reqData?.refreshToken) {
          localStorage.setItem("refreshToken", reqData.refreshToken);
        }

        const decoded = jwt_decode(reqData.accessToken);
        const allRoles =
          decoded?.role?.map((r) => r?.authority)?.filter(Boolean) ?? [];
        const userRole =
          getPrimaryRole(allRoles) || decoded?.role?.[0]?.authority;
        const resolvedAccountId = decoded?.id ?? accountId;

        let doctorDetails = {};
        try {
          const doctorRes = await dispatch(
            getVetDetailsById(resolvedAccountId),
          );
          if (
            doctorRes?.payload &&
            typeof doctorRes.payload === "object" &&
            !Array.isArray(doctorRes.payload)
          ) {
            doctorDetails = doctorRes.payload;
          }
        } catch {
          // continue switch even if doctor details fail
        }

        const nextUser = {
          ...account,
          ...doctorDetails,
          id: resolvedAccountId,
          doctorId:
            doctorDetails?.doctorId ?? account?.doctorId ?? resolvedAccountId,
          name: doctorDetails?.name ?? decoded?.name ?? account?.name,
        };
        localStorage.setItem("user", JSON.stringify(nextUser));
        if (userRole) {
          localStorage.setItem("role", userRole);
        }
        localStorage.setItem("allRoles", JSON.stringify(allRoles));
        if (resolvedAccountId) {
          localStorage.setItem("userId", resolvedAccountId);
        }

        saveAccessibleAccount(nextUser);

        dispatch(hideLoader());
        window.location.href = getNavigatePathByRole(userRole);
      },
    );
  };

  const handleLogoClick = () => {
    setSelectedTab("/dashboard");
    navigate("/dashboard");
  };

  const handleNotfClick = () => {
    setNotModVsble(!notModVsble);
  };

  const updateNotificationReadStatus = () => {
    const reqIds = notifications
      ?.filter((not) => !not?.view)
      ?.map((not) => {
        return not?.notificationId;
      });

    if (reqIds?.length > 0) {
      dispatch(markNotificationsReadByIds(reqIds?.toString())).then((res) => {
        if (res?.payload) dispatch(getClinicNotification());
      });
    }
  };

  const getReqUnReadCount = (cl) => {
    return profile?.id === cl?.userId ? cl?.reqUserCount : cl?.userCount;
  };

  const getUnReadChatCount = () => {
    return chatList?.length > 0
      ? chatList?.reduce((acc, obj) => acc + getReqUnReadCount(obj), 0)
      : 0;
  };

  const handleShowQR = () => {
    setAnchorElUser(null);
    setQrVsble(true);
  };

  const getProfileInitials = (name) => {
    const parts = String(name ?? "")
      ?.trim()
      ?.split(/\s+/)
      ?.filter(Boolean);
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return (parts[0]?.[0] ?? "U").toUpperCase();
  };

  const getRoleLabel = () => {
    if (role === "ROLE_CLINIC") return "Clinic"; //|| role === "ROLE_CLINICADMIN"
    if (role === "ROLE_CLINICSUPERADMIN") return "Super Admin";
    if (role === "ROLE_CLINICADMIN") return "Practice Manager";
    if (role === "ROLE_DOCTOR") return "Doctor";
    if (role === "ROLE_ADMIN") return "Admin";
    if (role === "ROLE_INVENTORY") return "Inventory";
    if (role === "ROLE_BILLING") return "Billing";
    if (role === "ROLE_RECEPTION") return "Reception";
    if (role === "ROLE_GROOMER") return "Groomer";
    if (role === "ROLE_RADIOLOGY") return "Radiology";
    if (role === "ROLE_PHARMACY") return "Pharmacy";
    return "User";
  };

  const getOrgName = () => mainClinicDetails?.name || "Vetinstant Healthcare";

  const truncateText = (text = "", max = 22) =>
    text.length > max ? `${text.slice(0, max)}...` : text;

  const handleProfileSettings = () => {
    if (role === "ROLE_DOCTOR") {
      navigate("/vet-calendar");
      setAnchorElUser(false);
      return;
    }
    if (role === "ROLE_CLINIC") {
      //|| role === "ROLE_CLINICADMIN"
      navigate("/clinic-consultation");
      setAnchorElUser(false);
      return;
    }
    handleEditProfile();
  };

  const handleEditProfile = () => {
    setAnchorElUser(null);
    setProfileEditModVisible(true);
  };

  const renderUserMenuRow = (icon, label, onClick) => (
    <Box
      className="user-menu-row"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") onClick();
      }}
    >
      <Box className="user-menu-row-icon">{icon}</Box>
      <Typography className="user-menu-row-label">{label}</Typography>
      <ChevronRightIcon className="user-menu-row-chevron" />
    </Box>
  );

  const handleViewNotification = (not) => {
    if (
      not?.title === "Call Reminder" ||
      not?.title === "Appointment Reminder" ||
      not?.title === "Vaccination Reminder"
    ) {
      // if (not?.appointmentId) {
      //   dispatch(getPetsCompliantSummary(not?.appointmentId));
      // } else if (not?.petId) {
      //   dispatch(getPetDetailsById(not?.petId));
      // }
      navigate(`/clinic-pet-details`, {
        state: {
          appointment: {
            appoinment: {
              appointmentId: not?.appointmentId,
              petId: not?.petId,
              userId: not?.userId,
            },
          },
        },
      });
    }
    if (
      not?.title === "Appointment Request" ||
      not?.title === "Appointment Scheduled"
    ) {
      navigate("/appointments", {
        state: {
          selectedTab:
            not?.title === "Appointment Scheduled" ? "calendar" : "requests",
        },
      });
    }
    if (
      not?.title === "Appointment Call-in" ||
      not?.title === "Appointment Check-in"
      //  ||
      // not?.title === "Task Assignment"
    ) {
      navigate("/dashboard", {
        state: {
          selectedTab:
            // not?.title === "Task Assignment" ? "Inpatient" :
            "Outpatient",
        },
      });
    }

    setNotModVsble(false);
  };

  const getAssociatedBranchIds = () => {
    const mandate = readMandateSession();
    const userId = profile?.doctorId ?? profile?.id;
    const vets = Array.isArray(mandate?.vets) ? mandate.vets : [];
    const vet = vets.find((vt) =>
      [vt?.doctorId, vt?.id, vt?.userId].some(
        (id) => id != null && String(id) === String(userId),
      ),
    );
    const raw =
      vet?.associatedBranches ??
      profile?.associatedBranches ??
      mandate?.clinic?.associatedBranches ??
      [];
    if (Array.isArray(raw)) {
      return raw
        .map((b) => (typeof b === "object" ? (b?.id ?? b?.value) : b))
        .filter((id) => id != null && id !== "")
        .map(String);
    }
    if (typeof raw === "string" && raw.trim() !== "") {
      return raw
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
    }
    return [];
  };

  const isMainClinicProfile = useMemo(() => {
    const clinicBranches = Array.isArray(readMandateSession()?.clinicBranches)
      ? readMandateSession()?.clinicBranches
      : [];
    return clinicBranches?.some(
      (branch) =>
        branch?.id != null &&
        String(branch?.id) === String(profile?.id) &&
        !branch?.branchNumber,
    );
  }, [profile?.id, mandateTick]);

  const isClinicSuperAdmin =
    role === "ROLE_CLINICSUPERADMIN" ||
    parseAllRoles().includes("ROLE_CLINICSUPERADMIN");
  const canSwitchBranch =
    role === "ROLE_DOCTOR" || isClinicSuperAdmin || isMainClinicProfile;

  const switchBranchList = useMemo(() => {
    if (!canSwitchBranch) return [];
    const mandate = readMandateSession();
    const clinicBranches = Array.isArray(mandate?.clinicBranches)
      ? mandate.clinicBranches
      : [];
    const activeBranches = clinicBranches.filter(
      (branch) => branch?.active === "Y",
    );
    const associatedIds = new Set(getAssociatedBranchIds());
    const sourceBranches =
      role === "ROLE_DOCTOR"
        ? activeBranches.filter((branch) =>
            associatedIds.has(String(branch?.id ?? "")),
          )
        : activeBranches;
    if (sourceBranches.length === 0) return [];
    return sourceBranches
      .map((branch) => ({
        name: branch?.branchName ?? "",
        value: branch?.id ?? null,
      }))
      .filter((branch) => branch.name && branch.value != null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, profile?.id, profile?.doctorId, mandateTick, canSwitchBranch]);

  const currentActiveBranchId = useMemo(() => {
    const mandate = readMandateSession();
    return (
      profile?.activeBranchId ??
      mandate?.clinic?.id ??
      profile?.createdBy ??
      localStorage.getItem("hospitalId") ??
      null
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.id, profile?.activeBranchId, mandateTick]);

  const clinic = useMemo(
    () => readMandateSession()?.clinic ?? null,
    [mandateTick],
  );

  const handleOpenBranchMenu = (event) => {
    setBranchMenuEl(event.currentTarget);
  };

  const handleCloseBranchMenu = () => {
    setBranchMenuEl(null);
  };

  const persistActiveBranchId = (branchId) => {
    if (branchId == null) return null;
    let nextUser = null;
    try {
      const storedUser = localStorage.getItem("user");
      const parsedUser = storedUser ? JSON.parse(storedUser) : {};
      nextUser = {
        ...(parsedUser && typeof parsedUser === "object" ? parsedUser : {}),
        activeBranchId: branchId,
      };
      localStorage.setItem("user", JSON.stringify(nextUser));
      saveAccessibleAccount(nextUser);
    } catch {
      // ignore localStorage write errors
    }
    return nextUser;
  };

  const handleSwitchBranch = (branchId) => {
    if (!branchId) return;
    if (
      currentActiveBranchId != null &&
      String(branchId) === String(currentActiveBranchId)
    ) {
      handleCloseBranchMenu();
      return;
    }
    handleCloseBranchMenu();
    dispatch(showLoader());
    dispatch(updateUserActiveBranch(branchId)).then((res) => {
      if (!res?.payload) {
        dispatch(hideLoader());
        return;
      }
      persistActiveBranchId(branchId);
      try {
        sessionStorage.removeItem(MANDATE_STORAGE_KEY);
      } catch {
        // ignore session clear errors
      }
      dispatch(logout());
      window.location.href = "/dashboard";
    });
  };

  const getBranchList = () => {
    // if (role !== "ROLE_DOCTOR") return [];
    const reqList = branchesByClinicId
      ?.filter(
        (li) =>
          // li?.id !== profile?.id &&
          li?.active === "Y",
      )
      ?.map((li) => ({
        name: li?.branchName,
        value: li?.branchName,
        branchId: li?.id,
      }));
    // if (mainClinicDetails?.doctorId) {
    //   reqList.push({
    //     name: mainClinicDetails?.name,
    //     value: mainClinicDetails?.name,
    //     branchId: mainClinicDetails?.doctorId,
    //   });
    // }
    return reqList ?? [];
  };

  const onAddAccount = () => {
    setAnchorElUser(null);
    setAddAccValues({ email: "", password: "" });
    setAddAccModVsble(true);
  };

  const onRemoveAllAccounts = () => {
    clearAccessibleAccounts();
    setAccessibleAccounts([]);
    dispatch(logout());
    localStorage.removeItem("switchedFrom");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("role");
    localStorage.removeItem("allRoles");
    localStorage.removeItem("userId");
    localStorage.removeItem("hospitalId");
    localStorage.removeItem("fcmToken");
    localStorage.removeItem("user");
    localStorage.removeItem("presApiSaved");
    localStorage.removeItem("presUnsavedList");
    localStorage.removeItem("unSavedProced");
    localStorage.removeItem("unSavedWorkbook");
    navigate("/login");
    setAnchorElUser(null);
  };

  const onCloseAddAccMod = () => {
    setAddAccModVsble(false);
    setAddAccValues({});
  };

  const onAddAccountToProfile = async () => {
    if (addAccValues?.email === "" || addAccValues?.password === "") {
      setAddAccValues({
        ...addAccValues,
        emailErr: addAccValues?.email === "",
        emailHlp: addAccValues?.email === "" ? "This field is required" : "",
        passwordErr: addAccValues?.password === "",
        passwordHlp:
          addAccValues?.password === "" ? "This field is required" : "",
      });
      return;
    }
    dispatch(showLoader());
    const user = {
      username: addAccValues?.email,
      password: addAccValues?.password,
    };
    try {
      const res = await api({ contentType: true }).post("/clinic/login", user);
      if (res?.status === 200) {
        if (res?.data?.accessToken?.length > 0) {
          const token = res?.data?.accessToken;
          const decoded = jwt_decode(token);
          if (decoded?.id) {
            dispatch(getVetDetailsById(decoded?.id)).then((accRes) => {
              if (accRes?.payload?.id || accRes?.payload?.doctorId) {
                saveAccessibleAccounts([profile, accRes.payload]);
                dispatch(
                  showSnackBar({
                    message: "Account added successfully!",
                    type: "success",
                  }),
                );
                onCloseAddAccMod();
              }
            });
          }
          dispatch(hideLoader());
        } else {
          const errorMsg =
            res?.data?.message || "Invalid Username or Password!";
          setAddAccValues({
            ...addAccValues,
            formErr: errorMsg,
            emailErr:
              errorMsg.toLowerCase().includes("user") ||
              errorMsg.toLowerCase().includes("email"),
            passwordErr: errorMsg.toLowerCase().includes("password"),
          });
          dispatch(hideLoader());
        }
      } else {
        const errorMsg = res?.data?.message || "Invalid Username or Password!";
        setAddAccValues({
          ...addAccValues,
          formErr: errorMsg,
        });
        dispatch(hideLoader());
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.message ||
        err?.message ||
        "An error occurred. Please try again.";
      const isPasswordErr =
        err?.response?.status === 401 ||
        err?.status === 401 ||
        errorMsg.toLowerCase().includes("password");
      const isUserErr =
        err?.response?.status === 404 ||
        err?.status === 404 ||
        errorMsg.toLowerCase().includes("user") ||
        errorMsg.toLowerCase().includes("email");

      setAddAccValues({
        ...addAccValues,
        formErr: errorMsg,
        ...(isPasswordErr ? { passwordErr: true } : {}),
        ...(isUserErr ? { emailErr: true } : {}),
      });
      dispatch(hideLoader());
    }
  };

  const onAddValuesChange = (name, value) => {
    const reqObj = { ...addAccValues, [name]: value, formErr: "" };
    if (name === "email") {
      reqObj.emailErr = value?.length === 0;
      reqObj.emailHlp = value?.length === 0 ? "This field is required" : "";
    }
    if (name === "password") {
      reqObj.passwordErr = value?.length === 0;
      reqObj.passwordHlp = value?.length === 0 ? "This field is required" : "";
    }
    setAddAccValues(reqObj);
  };

  const handleAddAccountKeyDown = (e) => {
    if (e.keyCode === 13) {
      onAddAccountToProfile();
    }
  };

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: "auto" }} className="topBar-minh">
          <Box sx={{ flexGrow: 1, display: { xs: "flex" } }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleLogoClick}
              sx={{ mr: 2 }}
            >
              <img
                src={require("../../assets/images/png/VetInstantLogo.png")}
                alt="../../assets/images/png/VetInstantLogo.png"
                style={{ objectFit: "contain", height: 30 }}
              />
            </IconButton>
            <Box
              sx={{
                flexGrow: 1,
                display: {
                  xs: "flex",
                  sm: "flex",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
              className="nav-flex-end w100Per"
            >
              {navItems.map((nav) => {
                const isSelected =
                  selectedTab === nav.path ||
                  (nav.path !== "/" && selectedTab?.startsWith(`${nav.path}/`));

                return (
                  <Tooltip
                    title={nav.title}
                    style={{ textTransform: "capitalize" }}
                  >
                    <a
                      key={nav.path}
                      href={nav.path}
                      onClick={(e) => {
                        e.preventDefault();
                        setSelectedTab(nav.path);
                        navigate(nav.path);
                      }}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <IconButton
                        className={
                          isSelected ? "tab-selected" : "tab-un-selected"
                        }
                        sx={{
                          display: "block",
                          ml: 1,
                          mr: 1,
                          "& svg": {
                            transition: "fill 0.3s ease",
                            width: 20,
                            height: 20,
                            fill: AppColors.white, // Default fill color
                          },
                          "&:hover svg": {
                            fill: AppColors.appPrimary, // Hover color
                            width: 20,
                            height: 20,
                          },
                          ...(isSelected && {
                            "& svg": {
                              fill: AppColors.appPrimary, // Selected color
                              width: 20,
                              height: 20,
                            },
                          }),
                        }}
                      >
                        {nav?.image ? (
                          <div className="flex-center">
                            <img
                              src={nav?.image}
                              style={{
                                height: 20,
                                width: 20,
                                objectFit: "contain",
                              }}
                              alt=""
                            />
                          </div>
                        ) : (
                          nav.icon
                        )}
                        <div
                          className={`fs7 font-medium ${isSelected ? "blue-color" : "white-color"} mb5`}
                        >
                          {nav?.title}
                        </div>
                        {nav?.title === "Appointments" &&
                          nav?.path === "/appointments" &&
                          appointemnts?.length > 0 && (
                            <div className="red-dot top-bar-dot-pos" />
                          )}
                      </IconButton>
                    </a>
                  </Tooltip>
                );
              })}
            </Box>

            <Box
              sx={{
                flexGrow: 0,
                display: {
                  xs: "flex",
                  sm: "flex",
                  md: "flex",
                  lg: "flex",
                  xl: "flex",
                },
              }}
              className="flex1-end"
            >
              <Tooltip title="Support" style={{ textTransform: "capitalize" }}>
                <IconButton
                  key="/support"
                  onClick={() => {
                    setSelectedTab("/support");
                    navigate("/support");
                  }}
                  className={
                    selectedTab === "/support"
                      ? "tab-selected"
                      : "tab-un-selected"
                  }
                  sx={{
                    display: "block",
                    mr: 1,
                    mt: 1,
                    "& svg": {
                      transition: "fill 0.3s ease",
                      width: 20,
                      height: 20,
                      fill: AppColors.white,
                    },
                    "&:hover svg": {
                      fill: AppColors.appPrimary,
                      width: 20,
                      height: 20,
                    },
                    ...(selectedTab === "/support" && {
                      "& svg": {
                        fill: AppColors.appPrimary,
                        width: 20,
                        height: 20,
                      },
                    }),
                  }}
                >
                  <HelpOutlineIcon />
                  <div
                    className={`fs7 font-medium ${selectedTab === "/support" ? "blue-color" : "white-color"} mb5`}
                  >
                    Support
                  </div>
                </IconButton>
              </Tooltip>

              {role !== "ROLE_ADMIN" && (
                <Tooltip title="Chat" style={{ textTransform: "capitalize" }}>
                  <IconButton
                    key="/chat"
                    onClick={() => {
                      setSelectedTab("/chat");
                      navigate("/chat");
                    }}
                    className={
                      selectedTab === "/chat"
                        ? "tab-selected"
                        : "tab-un-selected"
                    }
                    sx={{
                      display: "block",
                      mr: 1,
                      mt: 1,
                      "& svg": {
                        transition: "fill 0.3s ease",
                        width: 20,
                        height: 20,
                        fill: AppColors.white, // Default fill color
                      },
                      "&:hover svg": {
                        fill: AppColors.appPrimary, // Hover color
                        width: 20,
                        height: 20,
                      },
                      ...(selectedTab === "/chat" && {
                        "& svg": {
                          fill: AppColors.appPrimary, // Selected color
                          width: 20,
                          height: 20,
                        },
                      }),
                    }}
                  >
                    <ForumIcon />
                    {getUnReadChatCount() > 0 && (
                      <div className="not-count not-count-pos">
                        <Typography className="white-color header fs8">
                          {getUnReadChatCount()}
                        </Typography>
                      </div>
                    )}
                    <div
                      className={`fs7 font-medium ${selectedTab === "/chat" ? "blue-color" : "white-color"} mb5`}
                    >
                      Chat
                    </div>
                  </IconButton>
                </Tooltip>
              )}

              {canSwitchBranch && switchBranchList?.length > 0 ? (
                <>
                  <Tooltip
                    title="Switch Branch"
                    style={{ textTransform: "capitalize" }}
                  >
                    <IconButton
                      onClick={handleOpenBranchMenu}
                      className={
                        Boolean(branchMenuEl)
                          ? "tab-selected"
                          : "tab-un-selected"
                      }
                      sx={{
                        display: "block",
                        mr: 1,
                        mt: 1,
                        "& svg": {
                          transition: "fill 0.3s ease",
                          width: 20,
                          height: 20,
                          fill: AppColors.white,
                        },
                        "&:hover svg": {
                          fill: AppColors.appPrimary,
                          width: 20,
                          height: 20,
                        },
                        "& .nav-tab-title": {
                          transition: "color 0.3s ease",
                        },
                        "&:hover .nav-tab-title": {
                          color: AppColors.appPrimary,
                        },
                        ...(Boolean(branchMenuEl) && {
                          "& svg": {
                            fill: AppColors.appPrimary,
                            width: 20,
                            height: 20,
                          },
                        }),
                      }}
                    >
                      <SwapHorizIcon />
                      <div
                        className={`nav-tab-title fs7 font-medium ${Boolean(branchMenuEl) ? "blue-color" : "white-color"} mb5`}
                      >
                        Branch
                      </div>
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={branchMenuEl}
                    open={Boolean(branchMenuEl)}
                    onClose={handleCloseBranchMenu}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    PaperProps={{
                      className: "switch-branch-menu-paper",
                      sx: { backgroundColor: "#fff", zIndex: 1500 },
                    }}
                    sx={{ zIndex: 1500 }}
                  >
                    <Typography className="fs12 txt-semi-bold blue-color ph15 pt10 pb5">
                      Switch Branch
                    </Typography>
                    {switchBranchList.map((branch) => {
                      const isActive =
                        currentActiveBranchId != null &&
                        String(branch?.value) === String(currentActiveBranchId);
                      return (
                        <MenuItem
                          key={String(branch?.value)}
                          selected={isActive}
                          disabled={isActive}
                          onClick={() => handleSwitchBranch(branch?.value)}
                        >
                          <Typography className="fs13 txt-regular">
                            {branch?.name}
                            {isActive ? " (Current)" : ""}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </Menu>
                </>
              ) : null}

              {role !== "ROLE_ADMIN" && (
                <Tooltip title="Notifications">
                  <IconButton
                    onClick={handleNotfClick}
                    sx={{
                      pr: 3,
                      "& svg": {
                        transition: "fill 0.3s ease",
                        width: 20,
                        height: 20,
                        fill: AppColors.white, // Default fill color
                      },
                      "&:hover svg": {
                        fill: AppColors.btnWhite, // Hover color
                        width: 20,
                        height: 20,
                      },
                    }}
                  >
                    <NotificationsNoneOutlinedIcon />
                    {notifications?.filter((not) => !not?.view)?.length > 0 && (
                      <div className="not-count not-count-pos">
                        <Typography className="white-color header fs8">
                          {notifications?.filter((not) => !not?.view)?.length}
                        </Typography>
                      </div>
                    )}
                  </IconButton>
                </Tooltip>
              )}

              <div className="flex-column">
                <Typography
                  variant="subtitle1"
                  noWrap
                  component="a"
                  sx={{
                    mr: 2,
                    fontSize: "12px",
                    display: { xs: "none", md: "flex" },
                    fontFamily: "Montserrat",
                    fontWeight: "500",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  {profile?.name}
                </Typography>
                <Typography
                  variant="caption"
                  noWrap
                  component="b"
                  sx={{
                    mr: 2,
                    fontSize: "10px",
                    display: { xs: "none", md: "flex" },
                    fontFamily: "Montserrat",
                    fontWeight: "400",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  {getRoleLabel()}
                </Typography>
                {clinic?.name && String(clinic?.id) !== String(profile?.id) ? (
                  <Typography
                    variant="caption"
                    noWrap
                    component="b"
                    sx={{
                      mr: 2,
                      fontSize: "8px",
                      display: { xs: "none", md: "flex" },
                      fontFamily: "Montserrat",
                      fontWeight: "400",
                      color: "#fff",
                      textDecoration: "none",
                    }}
                  >
                    {clinic?.name}
                  </Typography>
                ) : null}
              </div>
              <Tooltip title="My Profile">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar alt={profile?.image} src={profile?.image} />
                </IconButton>
              </Tooltip>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
                PaperProps={{
                  className: "user-menu-paper",
                  elevation: 8,
                }}
                MenuListProps={{ className: "user-menu-list" }}
              >
                <Box className="flex1-end">
                  {/* <Typography className="user-menu-org-name">
                    {truncateText(getOrgName())}
                  </Typography> */}
                  <Typography
                    className="user-menu-sign-out pr10"
                    onClick={handleLogout}
                  >
                    Logout
                  </Typography>
                </Box>

                <Box className="user-menu-profile">
                  <Avatar
                    alt={profile?.name}
                    src={profile?.image || undefined}
                    className="user-menu-avatar"
                  >
                    {!profile?.image ? getProfileInitials(profile?.name) : null}
                  </Avatar>
                  <Box className="user-menu-profile-info">
                    <Typography className="white-color fs14 txt-semi-bold">
                      {profile?.name}
                    </Typography>
                    <Typography className="txt-regular fs12 gray2">
                      {profile?.email || `${getRoleLabel()} account`}
                    </Typography>
                    <Box
                      className="user-menu-view-account"
                      onClick={handleProfileSettings}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ")
                          handleProfileSettings();
                      }}
                    >
                      <Typography className="txt-semi-bold fs12 gray2 underline">
                        View account
                      </Typography>
                      <OpenInNewIcon className="user-menu-view-account-icon" />
                    </Box>
                  </Box>
                </Box>

                {accessibleAccounts?.length > 0 ? (
                  <Box className="user-menu-accounts-scroll">
                    {accessibleAccounts.map((acc) => (
                      <Box
                        key={String(getAccessibleAccountId(acc))}
                        className="user-menu-other-account"
                        onClick={() => handleSwitchAccount(acc)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ")
                            handleSwitchAccount(acc);
                        }}
                      >
                        <Avatar
                          alt={acc?.name}
                          src={acc?.image || undefined}
                          className="user-menu-other-avatar"
                        >
                          {!acc?.image ? getProfileInitials(acc?.name) : null}
                        </Avatar>
                        <Box className="user-menu-other-info">
                          <Typography className="user-menu-other-name">
                            {acc?.name}
                          </Typography>
                          <Typography className="user-menu-other-email">
                            {acc?.email || "Account"}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                ) : null}

                <Divider className="user-menu-divider" />

                {/* {renderUserMenuRow(
                  <EditOutlinedIcon className="user-menu-item-icon" />,
                  "Edit Profile",
                  handleEditProfile,
                )} */}

                {renderUserMenuRow(
                  <QrCode2OutlinedIcon className="user-menu-item-icon" />,
                  "Show My QR",
                  handleShowQR,
                )}

                <Divider className="user-menu-divider" />
                <Box
                  className="user-menu-add-account"
                  onClick={onAddAccount}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") onAddAccount();
                  }}
                >
                  <Box className="user-menu-add-account-icon-wrap">
                    <PersonAddOutlinedIcon className="user-menu-add-account-icon" />
                  </Box>
                  <Typography className="user-menu-add-account-text">
                    Add another account
                  </Typography>
                </Box>
                <Box
                  className="user-menu-add-account"
                  onClick={onRemoveAllAccounts}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      onRemoveAllAccounts();
                  }}
                >
                  <Box className="user-menu-add-account-icon-wrap">
                    <PersonRemoveOutlinedIcon className="user-menu-add-account-icon" />
                  </Box>
                  <Typography className="user-menu-add-account-text">
                    Remove all accounts from the device
                  </Typography>
                </Box>
              </Menu>
            </Box>
          </Box>
        </Toolbar>
      </Container>
      <CustomModal open={qrVsble} onClose={() => setQrVsble(false)}>
        <div className="flex-center h100Per">
          <img
            src={`${baseURL}/generateQRCode?text=${
              role === "ROLE_CLINIC" ? profile?.id : profile?.createdBy
            }`}
            alt=""
            className="img-wh300"
          />
        </div>
      </CustomModal>
      {profileEditModVisible ? (
        <EditProfileModal
          open={profileEditModVisible}
          onClose={() => setProfileEditModVisible(false)}
          vetId={profile?.doctorId ?? profile?.id}
        />
      ) : null}

      <CustomModal
        open={addAccModVsble}
        onClose={onCloseAddAccMod}
        modal
        headerShown={false}
        modalWidth={30}
      >
        <div className="ph10" onKeyDown={handleAddAccountKeyDown}>
          <Typography className="fs14 txt-semi-bold blue-color">
            Add Account
          </Typography>
          <div className="mt10">
            <CustomTextField
              label="Username"
              placeholder="Username"
              name="email"
              fullWidth
              handleChange={(e) => onAddValuesChange("email", e?.target?.value)}
              value={addAccValues?.email}
              helperText={addAccValues?.emailHlp}
              error={addAccValues?.emailErr}
              startIcon
              inputIcon={<MailOutlineIcon />}
              mandatoryField
              labelTop
            />
          </div>
          <div className="mt10">
            <CustomTextField
              label="Password"
              placeholder="Password"
              name="password"
              fullWidth
              value={addAccValues?.password}
              handleChange={(e) =>
                onAddValuesChange("password", e?.target?.value)
              }
              showPassword={addAccValues?.showPassword}
              handleClickShowPassword={() =>
                onAddValuesChange("showPassword", !addAccValues?.showPassword)
              }
              helperText={addAccValues?.passwordHlp}
              error={addAccValues?.passwordErr}
              password
              inputIcon={<img src={keyIcon} className="key" />}
              type="password"
              mandatoryField
              labelTop
            />
          </div>

          {addAccValues?.formErr && (
            <div className="flex-center mt10">
              <Typography className="red-color fs12 font-medium">
                {addAccValues?.formErr}
              </Typography>
            </div>
          )}

          <div className="flex-center mv10">
            <div>
              <CustomButton
                text="Add Account"
                smallBtn
                onClick={onAddAccountToProfile}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={switchAccModVsble}
        onClose={handleCloseSwitchAccModal}
        header="Switch Account"
        modal
        modalWidth={28}
        headerShown={false}
      >
        <div className="font-bold fs14 ph15 blue-color">Switch Account</div>
        <Box className="switch-acc-modal-body">
          <Typography className="switch-acc-modal-subtitle">
            Choose an account to continue
          </Typography>
          {logoutSwitchAccounts?.length > 0 ? (
            <Box className="switch-acc-modal-list">
              {logoutSwitchAccounts.map((acc) => (
                <Box
                  key={String(getAccessibleAccountId(acc))}
                  className="switch-acc-modal-item"
                  onClick={() => handleSwitchAccount(acc, { fromLogout: true })}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      handleSwitchAccount(acc, { fromLogout: true });
                  }}
                >
                  <Avatar
                    alt={acc?.name}
                    src={acc?.image || undefined}
                    className="switch-acc-modal-avatar"
                  >
                    {!acc?.image ? getProfileInitials(acc?.name) : null}
                  </Avatar>
                  <Box className="switch-acc-modal-info">
                    <Typography className="switch-acc-modal-name">
                      {acc?.name}
                    </Typography>
                    <Typography className="switch-acc-modal-email">
                      {acc?.email || "Account"}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          ) : null}
        </Box>
      </CustomModal>
      {notModVsble && (
        <Modal
          open={notModVsble}
          onClose={() => setNotModVsble(false)}
          className="not-con-pos"
        >
          <Card className="br5 ph20pv15">
            <div className="flex-row-between-align-center">
              <Typography className="yellow-color fs16 font-bold">
                New for you
              </Typography>
              <Typography
                className="txt-regular fs14 black9 cursor"
                onClick={updateNotificationReadStatus}
              >
                Mark as read
              </Typography>
            </div>
            {notifications?.length > 0 ? (
              <div className="scroll-max-50vh">
                {notifications?.map((not, i) => (
                  <div
                    className="flex-row-between-align-center mv10 cursor"
                    key={not?.notificationId + i}
                    onClick={() => handleViewNotification(not)}
                  >
                    <div className="flex-row">
                      <div className="not-icon">
                        <img
                          className="img-wh15"
                          alt=""
                          src={require("../../assets/images/png/notIcon.png")}
                        />
                      </div>
                      <div className="mlMin15">
                        {not?.petImage ? (
                          <img
                            className="img-wh35 br6"
                            alt=""
                            src={not?.petImage}
                          />
                        ) : (
                          <div className="not-no-img">
                            <Typography className="font-bold fs26 white-color capitalize">
                              {not?.petName?.[0]}
                            </Typography>
                          </div>
                        )}
                      </div>
                      <div className="ml10 flex-column">
                        <Typography className="txt-regular fs14 black10 flex-row-wrap">
                          {not?.content}
                        </Typography>
                        <Typography className="txt-regular fs12 black9">
                          · {moment(not?.createdDate).format("MMM DD")} ·{" "}
                          {moment(not?.createdDate).format("HH:mm")}
                        </Typography>
                      </div>
                    </div>
                    {!not?.view && (
                      <div className="flex-center">
                        <div className="red-dot2" />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="no-rec h100">No records available</div>
            )}
          </Card>
        </Modal>
      )}
    </AppBar>
  );
};

Header.propTypes = {
  onOpenNav: PropTypes.func,
  search: PropTypes.bool,
  headerText: PropTypes.string,
  headerTextVisible: PropTypes.bool,
  isSwichProfileVisible: PropTypes.bool,
};

Header.defaultProps = {
  onOpenNav: () => {},
  search: false,
  headerText: "",
  headerTextVisible: false,
  isSwichProfileVisible: false,
};

export default Header;
